"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _withContainer = require("./withContainer");

var _withContainer2 = _interopRequireDefault(_withContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgCaretupSecondary = function SvgCaretupSecondary(props) {
    return _react2.default.createElement(
        "svg",
        Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 32" }, props),
        _react2.default.createElement("path", {
            d: "M15.99 14.96l7.08 6.99 1.68-1.7-8.76-8.66-8.74 8.66 1.68 1.7z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    );
};

exports.default = (0, _withContainer2.default)(SvgCaretupSecondary);